import ExternalReviews from './ExternalReviews.vue'

export default ExternalReviews
